import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { } from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain,
  Page,
  Support,
} from '../../components';
import config from '../../config';
import './supportmodule.global.scss';

interface Props {
  intl: any;
  scrollingDisabled: any;
}

const SupportManagementComponent: React.FC<Props> = (props: Props) => {
  const { intl, scrollingDisabled } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'SupportManagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <Support />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const SupportManagementComponentPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(SupportManagementComponent);

export default SupportManagementComponentPage;
